var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.settings.graphics && _vm.settings.graphics.mode == 'low'
      ? 'low_graphics'
      : null,attrs:{"id":"main-background"}},[_c('v-main',[_c('router-view')],1),_c('SiteMovedDialog'),(_vm.settings.debug)?_c('DebugTool'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }